import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import cls from 'classnames';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTag } from '@fortawesome/free-solid-svg-icons';

export default class DailyAttendanceEventIndicator extends React.Component {
    getEffectiveDailyAttendanceEvent = () => {
        const { dailyAttendanceEvents } = this.props;

        if (!dailyAttendanceEvents || !dailyAttendanceEvents.length) {
            return null;
        }

        const employeeDailyAttendanceEvent = this.getEffectiveEmployeeDailyAttendanceEvent();

        if (!employeeDailyAttendanceEvent) {
            return null;
        }

        return dailyAttendanceEvents.find(
            (dae) => employeeDailyAttendanceEvent.dailyAttendanceEventId == dae.id,
        );
    };

    getEffectiveEmployeeDailyAttendanceEvent = () => {
        const { staff, employeeDailyAttendanceEvents } = this.props;

        if (
            !staff
            || !employeeDailyAttendanceEvents
            || !employeeDailyAttendanceEvents.length
        ) {
            return null;
        }

        return employeeDailyAttendanceEvents.find(
            (edae) => edae.employeeId == staff.id,
        );
    };
    render() {
        const { staff } = this.props;

        const effectiveEmployeeDailyAttendanceEvent = this.getEffectiveEmployeeDailyAttendanceEvent();

        const effectiveDailyAttendanceEvent = this.getEffectiveDailyAttendanceEvent();

        if (!effectiveDailyAttendanceEvent) {
            return null;
        }

        const dailyAttendanceEventName = effectiveDailyAttendanceEvent?.name;

        const employeeDailyAttendanceEventDate = effectiveEmployeeDailyAttendanceEvent
            ? moment(effectiveEmployeeDailyAttendanceEvent.eventDate)
                .toDate()
                .toLocaleDateString()
            : null;

        const extraClass = effectiveDailyAttendanceEvent && effectiveDailyAttendanceEvent.employeeMayNotBeAssigned
            ? 'text-danger'
            : '';

        return (
            <>
                <FontAwesomeIcon
                    icon={faUserTag}
                    className={cls('cursor-pointer', extraClass)}
                    id={`dae-${staff.id}`}
                />

                <UncontrolledTooltip target={`dae-${staff.id}`}>
                    {`${dailyAttendanceEventName} (${employeeDailyAttendanceEventDate})`}
                </UncontrolledTooltip>
            </>
        );
    }
}
